// MotionFlex PDP - interactions
// 1. Sticky CTA reveal on scroll past hero
// 2. Gallery thumbnail click -> swap main image
// 3. Quantity +/- buttons
// 4. Sticky CTA "Add to cart" -> submit the in-page form
// 5. Variant option click -> resolve the real variant id, price and availability

(function () {
  'use strict';

  // ----- Sticky CTA reveal -----
  var sticky = document.querySelector('[data-sticky-cta]');
  var hero = document.getElementById('pdp-hero');
  if (sticky && hero) {
    sticky.removeAttribute('hidden');
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          sticky.dataset.active = e.isIntersecting ? 'false' : 'true';
        });
      },
      { rootMargin: '-200px 0px 0px 0px', threshold: 0 }
    );
    obs.observe(hero);
  }

  // ----- Sticky CTA -> submit form -----
  document.querySelectorAll('[data-sticky-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById('lumedaProductForm');
      if (!form) return;
      var submitBtn = form.querySelector('button[type=submit]');
      if (submitBtn && !submitBtn.disabled) form.requestSubmit(submitBtn);
    });
  });

  // ----- Gallery thumb click -----
  var mainImg = document.getElementById('lumedaGalleryMainImg');
  if (mainImg) {
    document.querySelectorAll('.lumeda-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.dataset.mediaUrl;
        if (!url) return;
        mainImg.src = url;
        document.querySelectorAll('.lumeda-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ----- Quantity +/- -----
  document.querySelectorAll('[data-qty-action]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('.lumeda-pdp__qty-input');
      if (!input) return;
      var cur = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      var next = btn.dataset.qtyAction === 'inc' ? Math.min(cur + 1, max) : Math.max(cur - 1, min);
      input.value = next;
    });
  });

  // ----- Variant resolution (multi-option safe) -----
  var dataEl = document.getElementById('lumedaPdpData');
  var payload = null;
  try { payload = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (err) { payload = null; }

  var groups = Array.prototype.slice.call(document.querySelectorAll('.lumeda-pdp__variant'));
  if (payload && payload.variants && groups.length) {
    var variants = payload.variants;
    var currency = payload.currency || 'AUD';
    var idInput = document.querySelector('#lumedaProductForm input[name="id"]');
    var priceCurrent = document.querySelector('.lumeda-pdp__price-current');
    var priceWas = document.querySelector('.lumeda-pdp__price-was');
    var priceSave = document.querySelector('.lumeda-pdp__price-save');
    var atcBtn = document.querySelector('.lumeda-pdp__atc');
    var atcText = document.querySelector('.lumeda-pdp__atc-text');
    var atcLabel = atcText ? (atcText.textContent || '').split(' — ')[0].trim() : 'ADD TO CART';

    function fmt(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (err) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function currentSelection() {
      return groups.map(function (g) {
        var sel = g.querySelector('.lumeda-pdp__variant-option.is-selected');
        return sel ? sel.dataset.optionValue : null;
      });
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] === null) { match = false; break; }
          if (String(v.options[j]) !== String(sel[j])) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function markUnavailable(sel) {
      // Grey out values that cannot combine with the rest of the selection.
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.lumeda-pdp__variant-option').forEach(function (btn) {
          var trial = sel.slice();
          trial[gi] = btn.dataset.optionValue;
          var ok = variants.some(function (v) {
            for (var j = 0; j < trial.length; j++) {
              if (trial[j] === null) continue;
              if (String(v.options[j]) !== String(trial[j])) return false;
            }
            return v.available;
          });
          btn.classList.toggle('is-unavailable', !ok);
          btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        });
      });
    }

    function sync() {
      var sel = currentSelection();
      markUnavailable(sel);
      var v = findVariant(sel);
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceCurrent) priceCurrent.textContent = fmt(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = fmt(v.compare_at_price);
          priceWas.style.display = '';
          if (priceSave) {
            priceSave.textContent = 'SAVE ' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
            priceSave.style.display = '';
          }
        } else {
          priceWas.style.display = 'none';
          if (priceSave) priceSave.style.display = 'none';
        }
      }

      if (atcBtn && atcText) {
        atcBtn.disabled = !v.available;
        atcText.textContent = v.available ? (atcLabel + ' — ' + fmt(v.price)) : 'Sold out';
      }

      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src;
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g) {
      var buttons = g.querySelectorAll('.lumeda-pdp__variant-option');
      var selectedLabel = g.querySelector('.lumeda-pdp__variant-selected');
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          buttons.forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          if (selectedLabel) selectedLabel.textContent = b.dataset.optionValue;
          sync();
        });
      });
    });

    sync();
  }
})();


/* =====================================================================
   UGC CAROUSEL - controls
   ===================================================================== */
(function () {
  function initUGC() {
    var sections = document.querySelectorAll('.lumeda-pdp__ugc');
    sections.forEach(function (section) {
      var track = section.querySelector('[data-ugc-track]');
      var prev  = section.querySelector('.lumeda-pdp__ugc-nav--prev');
      var next  = section.querySelector('.lumeda-pdp__ugc-nav--next');
      if (!track) return;

      function scrollByCard(dir) {
        var card = track.querySelector('.lumeda-pdp__ugc-card');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 18;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });

      var cards = section.querySelectorAll('.lumeda-pdp__ugc-card');
      cards.forEach(function (card) {
        var video = card.querySelector('[data-ugc-video]');
        var muteBtn = card.querySelector('[data-ugc-mute]');
        var playBtn = card.querySelector('[data-ugc-play]');
        var media = card.querySelector('.lumeda-pdp__ugc-media');
        if (!video) return;

        var muteOn  = card.querySelector('.lumeda-pdp__ugc-mute-on');
        var muteOff = card.querySelector('.lumeda-pdp__ugc-mute-off');
        var playIco = card.querySelector('.lumeda-pdp__ugc-play-icon');
        var pauseIco = card.querySelector('.lumeda-pdp__ugc-pause-icon');

        function syncPlayIcon() {
          if (video.paused) {
            card.classList.add('is-paused');
            if (playIco) playIco.style.display = '';
            if (pauseIco) pauseIco.style.display = 'none';
          } else {
            card.classList.remove('is-paused');
            if (playIco) playIco.style.display = 'none';
            if (pauseIco) pauseIco.style.display = '';
          }
        }
        function syncMuteIcon() {
          if (video.muted) {
            if (muteOn) muteOn.style.display = '';
            if (muteOff) muteOff.style.display = 'none';
          } else {
            if (muteOn) muteOn.style.display = 'none';
            if (muteOff) muteOff.style.display = '';
          }
        }
        video.addEventListener('play', syncPlayIcon);
        video.addEventListener('pause', syncPlayIcon);
        video.addEventListener('volumechange', syncMuteIcon);
        syncPlayIcon();
        syncMuteIcon();

        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (video.muted) {
              document.querySelectorAll('[data-ugc-video]').forEach(function (v) {
                if (v !== video) v.muted = true;
              });
            }
            video.muted = !video.muted;
          });
        }
        function togglePlay(e) {
          if (e) e.stopPropagation();
          if (video.paused) video.play().catch(function(){});
          else video.pause();
        }
        if (playBtn) playBtn.addEventListener('click', togglePlay);
        if (media)   media.addEventListener('click', togglePlay);
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = card.querySelector('[data-ugc-video]');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              card.classList.add('is-active');
              video.play().catch(function(){});
            } else {
              card.classList.remove('is-active');
              video.pause();
            }
          });
        }, { root: track, threshold: [0, 0.6, 0.9] });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
  document.addEventListener('shopify:section:load', initUGC);
})();
